module.exports = __webpack_public_path__ + "img/coristech.7a47d1c5.jpg";